import { match } from "ts-pattern";

import { type CuratedPlaceOfSafety } from "@thalamos/common";

import type { IncidentWorkItemWithContext } from "../../types/incidentWorkItem.js";
import { getWorkflowTranslationContext } from "../../workflowLogic/helpers/getWorkflowTranslationContext.js";

export const includeOnlyEmergencyDepartmentForMca = (context: {
  incidentWorkItem?: IncidentWorkItemWithContext;
}) =>
  match(getWorkflowTranslationContext(context))
    .with("136", undefined, () => undefined)
    .with(
      "mca",
      () => (place: CuratedPlaceOfSafety) =>
        place.posType === "emergencyDepartment",
    )
    .exhaustive();
